module.exports = __webpack_public_path__ + "static/media/SC.c56b6631.png";